import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { ResultsRoutes } from './results.routes';
import { ListResultsComponent } from './list-results/list-results.component';
import { FormResultsComponent } from './_components/form-results/form-results.component';
import { AddResultsComponent } from './add-results/add-results.component';
import { EditResultsComponent } from './edit-results/edit-results.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        ResultsRoutes,
        SharedDocumalisModule,
        TranslateModule
    ],
    declarations: [
        ListResultsComponent,
        AddResultsComponent,
        EditResultsComponent,
        FormResultsComponent,
    ]
})
export class ResultsModule { }
